import { useState, useLayoutEffect, RefObject } from 'react';

export const useTableHeight = (ref: RefObject<HTMLElement | null>, offset: number = 24) => {
    const [height, setHeight] = useState<number | null>(null);

    useLayoutEffect(() => {
        const updateHeight = () => {
            if (ref.current) {
                const rect = ref.current.getBoundingClientRect();
                const availableHeight = window.innerHeight - rect.top - offset;
                setHeight(availableHeight > 0 ? availableHeight : 300); // Fallback to 300 if top is somehow more than innerHeight
            }
        };

        // Delay slightly or ensure it runs after content is rendered
        const timeoutId = setTimeout(updateHeight, 50);

        window.addEventListener('resize', updateHeight);
        return () => {
            window.removeEventListener('resize', updateHeight);
            clearTimeout(timeoutId);
        };
    }, [ref, offset]);

    return height;
};

export default useTableHeight;
